import './App.css';
import words from './words.json';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useToPng, useToSvg, useToBlob } from '@hugocxl/react-to-image';
import dayjs from "dayjs";
import weekOfYearPlugin from "dayjs/plugin/weekOfYear";
dayjs.extend(weekOfYearPlugin);


function App() {
  // function requestAccess(){
  //   if(navigator.permissions && navigator.permissions.query){
  //     navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
  //       console.log(result)
  //     });
  //   }
  // }
  const [state, convert] = useToBlob({
    selector: '#bingo-board',
    onSuccess: data => {
      navigator.clipboard.write([new ClipboardItem({'image/png': new Promise((resolve,reject)=>{resolve(data)})})])
    },
  })
  function getExpiry(){
    const dayINeed = 0;
    const today = dayjs().day();

    // if we haven't yet passed the day of the week that I need:
    if (today <= dayINeed) { 
      // then just give me this week's instance of that day
      return dayjs().day(dayINeed).hour(23).minute(59).second(59).toDate();
    } else {
      // otherwise, give me *next week's* instance of that same day
      return dayjs().add(1, 'weeks').day(dayINeed).hour(23).minute(59).second(59).toDate();
    }
  }
  function shuffle(array) {
    let currentIndex = array.length,  randomIndex;
    while (currentIndex > 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  }
  const [wordPool,setWordPool] = useState([[],[],[],[],[]])
  const [markers,setMarkers] = useState([[false,false,false,false,false],[false,false,false,false,false],[false,false,false,false,false],[false,false,false,false,false],[false,false,false,false,false]]);
  let pool=[[],[],[],[],[]];
  useEffect(()=>{
    if(Cookies.get('lb-board')&&Cookies.get('lb-markers')){
      setWordPool(JSON.parse(Cookies.get('lb-board')))
      setMarkers(JSON.parse(Cookies.get('lb-markers')))
    }else{
      let expiry = getExpiry();
      shuffle(words.words);
      for(let i=0;i<5;i++){
        for(let j=0;j<5;j++){
          let myWord = words.words.shift();
          pool[i].push(myWord)
        }
      }
      setWordPool(pool);
      Cookies.set('lb-board',JSON.stringify(pool),{expires:expiry});
      Cookies.set('lb-markers',JSON.stringify(markers),{expires:expiry});
    }
    
  },[]);
  function mark(r,c){
    let expiry = getExpiry();
    let tempMarkers = [...markers];
    tempMarkers[r][c]=!tempMarkers[r][c];
    setMarkers(tempMarkers)
    Cookies.set('lb-markers',JSON.stringify(tempMarkers),{expires:expiry})
  }
  return (
      <div style={{marginTop:'40px'}}>
      <table style={{margin:'auto'}}>
        <thead></thead>
        <tbody id="bingo-board">
          <tr>
            <td colSpan={5} style={{backgroundColor:'#7C101C',color:'#fff'}}><h2>LAWLER BINGO!</h2></td>
          </tr>
          <tr key={0}>
            {wordPool[0].map((w,i)=>{
              return(<td key={i} onClick={()=>{mark(0,i)}} style={{backgroundColor:markers[0][i]?'#ccc':'#fff'}}>{`${w}`}</td>)
            })}
          </tr>
          <tr key={1}>
            {wordPool[1].map((w,i)=>{
              return(<td key={i} onClick={()=>{mark(1,i)}} style={{backgroundColor:markers[1][i]?'#ccc':'#fff'}}>{`${w}`}</td>)
            })}
          </tr>
          <tr key={2}>
            {wordPool[2].map((w,i)=>{
              return(<td key={i} onClick={()=>{mark(2,i)}} style={{backgroundColor:markers[2][i]?'#ccc':'#fff'}}>{`${w}`}</td>)
            })}
          </tr>
          <tr key={3}>
            {wordPool[3].map((w,i)=>{
              return(<td key={i} onClick={()=>{mark(3,i)}} style={{backgroundColor:markers[3][i]?'#ccc':'#fff'}}>{`${w}`}</td>)
            })}
          </tr>
          <tr key={4}>
            {wordPool[4].map((w,i)=>{
              return(<td key={i} onClick={()=>{mark(4,i)}} style={{backgroundColor:markers[4][i]?'#ccc':'#fff'}}>{`${w}`}</td>)
            })}
          </tr>
        </tbody>
        <tfoot></tfoot>
      </table>
      <div style={{textAlign:'center',marginTop:'20px'}}>
        <button onClick={convert} style={{padding:'12px',backgroundColor:'#7C101C',color:'#fff',border:'0',fontWeight:'bold',borderRadius:'4px'}}>Share to Clipboard</button>
      </div>
      </div>
  );
}

export default App;
